var _radialGradient, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTubeSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a12",
    cx: 0.66,
    fx: 0.66,
    cy: 0.3125,
    fy: 0.3125,
    gradientTransform: "scale(1.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#007AFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#007AFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#007AFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF",
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "transform-origin": "center",
    fill: "none",
    stroke: "url(#a12)",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeDasharray: "200 1000",
    strokeDashoffset: 0,
    cx: 100,
    cy: 100,
    r: 70
  }, /*#__PURE__*/React.createElement("animateTransform", {
    type: "rotate",
    attributeName: "transform",
    calcMode: "spline",
    dur: 2,
    values: "360;0",
    keyTimes: "0;1",
    keySplines: "0 0 1 1",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "transform-origin": "center",
    fill: "none",
    opacity: 0.2,
    stroke: "#007AFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    cx: 100,
    cy: 100,
    r: 70
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeSpinner);
export default __webpack_public_path__ + "static/media/tube-spinner.049e24e5ae85aaa45fdfb1e47abb6664.svg";
export { ForwardRef as ReactComponent };